import React from 'react'

import Loader from 'assets/svg/loader.gif'

import {
    Products,
    Line,
    Error,
    Loading,
    Content,
    Title,
    List,
    Button
} from './ProductsContent.style'

const ProductsContent = ({
    main = true,
    mobile,
    loading,
    error,
    onRetry,
    children
}) => (
    <Products $main={main} $mobile={mobile}>
        {!main && <Line $mobile={mobile} />}
        <Content $mobile={mobile}>
            <Title $mobile={mobile}>
                <span>
                    Ofereça aos seus colaboradores
                    <br />
                    <strong>Os Melhores Benefícios do mercado</strong>
                </span>
            </Title>
            <List $main={main} $mobile={mobile}>
                {loading && (
                    <Loading $mobile={mobile}>
                        <img src={Loader} alt="loading" />
                        <span>Carregando produtos...</span>
                    </Loading>
                )}
                {error && (
                    <Error $mobile={mobile}>
                        <span>{error}</span>
                        <Button onClick={onRetry}>
                            Recarregar página inicial
                        </Button>
                    </Error>
                )}
                {children}
            </List>
        </Content>
    </Products>
)

export default ProductsContent
